<template>
  <div class="job-options" v-title data-title="新增明细">
    <header>
      <div class="content-top">
        <!-- 时间选项 -->
        <div class="date-option" @click="showPopup">
          <span>
            {{search_time}}<img src="../../assets/images/partner-img/partner-information/16.png" alt="">
          </span>
        </div>
        <p class="statistics">
          <span>
            新增绩效期权：{{share_option_msg.schedule_nu}}
          </span>
          <span>
            共计：{{share_option_msg.all_nu}}
          </span>
        </p>
      </div>
    </header>
    <section>
      <div class="share-option-list">
        <div class="share-option-list-content" v-for="(item,index) in share_option_msg.info" :key="index">
          <p>
            <span>
              {{item.content}}
            </span>
            <span>
              {{item.create_time}}
            </span>
          </p>
          <p>
            +{{item.point}}
          </p>
        </div>
      </div>
    </section>
    <van-popup v-model="show"  position="bottom" :style="{ height: '40%' }" >
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @cancel="show = false"
        @confirm="confirm_btn"
      />
    </van-popup>
  </div>
</template>

<script>

import Vue from 'vue';
import { DatetimePicker, Popup } from 'vant';

Vue.use(DatetimePicker);
Vue.use(Popup);

export default {
  data() {
    return {
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      show: false,
      search_time: '本月', // 时间搜索
      share_option_msg: [] // 期权数据
    };
  },
  created(){
    // 岗位期权
    let uid = JSON.parse(localStorage.getItem("uid"));
    this.$axios.post(this.domain.url+"/api/order/index/optionsList",{
      uid : uid,
      type : 1
    }).then((res) => {
      // console.log(res.data.data)
      this.share_option_msg = res.data.data
    })
  },
  methods: {
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    showPopup(){
      this.show = true
    },
    // 选择时间筛选
    confirm_btn(){
      this.search_time = this.currentDate.getFullYear() + '-' + (this.currentDate.getMonth() + 1)
      let uid = JSON.parse(localStorage.getItem("uid"));
      this.$axios.post(this.domain.url+"/api/order/index/optionsList",{
        uid : uid,
        type : 1,
        search_time : this.search_time
      }).then((res) => {
        // console.log(res)
        this.share_option_msg = res.data.data
      })
      this.show = false
    }
  },
}
</script>

<style lang="less" scoped>
  .job-options{
    width: 7.5rem;
    display: flex;
    flex-direction: column;
    background: #f4f4f4;
    header{
      .content-top{
        width: 7.5rem;
        height: 1.29rem;
        overflow: hidden;
        .date-option{
          background: #fff;
          border-radius: .24rem;
          margin-top: .4rem;
          margin-left: .2rem;
          float: left;
          font-size: 0.26rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #212121;
          text-align: center;
          line-height: .26rem;
          padding: .12rem .12rem .12rem .21rem;
          img{
            width: .07rem;
            height: .05rem;
            margin-bottom: .1rem;
            margin-left: .1rem;
          }
        }
        .statistics{
          float: right;
          font-size: 0.24rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #A1A1A1;
          margin-right: .12rem;
          span{
            display: block;
            &:first-child{
              margin-top: .3rem;
            }
          }
        }
      }
    }
    section{
      .share-option-list{
        width: 7.1rem;
        margin: 0 auto;
        background: #fff;
        .share-option-list-content{
          width: 6.85rem;
          height: 1.35rem;
          background: #fff;
          margin: 0 auto;
          border-bottom: .01rem #EDEDEF solid;
          p{
            text-align: center;
            &:first-child{
              float: left;
              span{
                display: block;
                line-height: .4rem;
                &:first-child{
                  font-size: 0.24rem;
                  font-family: PingFang SC;
                  font-weight: 600;
                  color: #212121;
                  margin-top: .35rem;
                }
                &:last-child{
                  font-size: 0.24rem;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #919191;
                }
              }
            }
            &:last-child{
              float: right;
              font-size: 0.36rem;
              font-family: PingFang SC;
              font-weight: bold;
              color: #FF6600;
              line-height: 1.35rem;
            }
          }
        }
      }
    }
  }
</style>